export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes";
export const TIMEOUT_SECONDS = 10
export const RES_PER_PAGE = 10
export const API_KEY = "f7743354-e7a0-48d1-a24a-e65eb1e1be2a";
export const MODAL_CLOSE_SEC = 1500;
export const FORM_RESET_SEC = 2500;